import { tryGet, tryPost, tryPut, tryDelete } from './index';

export const getHydrantDeficiencies = async () => {
  console.log('Getting Hydrant Deficiencies');
  const result = await tryGet(`/hydrantDeficiencies`);
  console.log('Hydrant Deficiencies', result);
  return result.data;
};
export const getHydrantDeficienciesByHydrantId = async (hydrantId) => {
  console.log('Getting Hydrant Deficiencies by Hydrant ID:', hydrantId);
  const result = await tryGet(`/hydrantDeficiencies/byHydrantId/${hydrantId}`);
  console.log('Hydrant Deficiencies', result);
  return result.data;
};

export const getHydrantDeficiency = async (hydrantDeficiencyId) => {
  const result = await tryGet(`/hydrantDeficiencies/${hydrantDeficiencyId}`);
  return result.data;
};

export const getHydrantDeficiencyEdit = async (hydrantDeficiencyId) => {
  const result = await tryGet(`/hydrantDeficiencies/${hydrantDeficiencyId}/edit`);
  return result.data;
};

export const updateHydrantDeficiency = async (hydrantDeficiency) => {
  const result = await tryPut(`/hydrantDeficiencies`, hydrantDeficiency);
  return result.data;
};

export const addHydrantDeficiency = async (hydrantDeficiency) => {
  const result = await tryPost(`/hydrantDeficiencies`, hydrantDeficiency);
  return result.data;
};

export const deleteHydrantDeficiency = async (hydrantDeficiencyId) => {
  const result = await tryDelete(`/hydrantDeficiencies/${hydrantDeficiencyId}`);
  return result.data;
};
